export const materials = () => {
  let columns = $(".materials--table").data("columns");
  let columnWidth = $(".materials--table--cell")
    .not(".materials--table--cell--category")
    .outerWidth();
  let offset = 0;
  let tableWidth = $(".materials--table").outerWidth();
  let displaying = Math.floor(tableWidth / columnWidth);

  $(".materials--paginate--left").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("is-disabled")) {
      return;
    }

    offset -= 1;

    let translateAmount = columnWidth * offset;

    $(".materials--table--cell")
      .not(".materials--table--cell--category")
      .css("transform", "translateX(-" + translateAmount + "px)");

    if (offset === 0) {
      $(this).addClass("is-disabled");
    }

    $(".materials--paginate--right").removeClass("is-disabled");
  });

  $(".materials--paginate--right").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("is-disabled")) {
      return;
    }

    offset += 1;

    let translateAmount = columnWidth * offset;

    $(".materials--table--cell")
      .not(".materials--table--cell--category")
      .css("transform", "translateX(-" + translateAmount + "px)");

    if (offset + displaying === columns) {
      $(this).addClass("is-disabled");
    }

    $(".materials--paginate--left").removeClass("is-disabled");
  });
};
